import { PayPerListingPackageDataType } from "../../interfaces/payPerListingPackage/PayPerListingPackage.type";
import styles from "./PayPerListingPackage.module.css";
import PayPerListingPackage from "./PayPerListingPackage";
import { useState } from "react";

export default function PayPerListingPackageContainer({
  items,
}: {
  items: PayPerListingPackageDataType[];
}) {
  const item = items[0];
  return (
    <div className={`vas-w-100 vas-py-2`}>
      <PayPerListingPackage item={item} />
    </div>
  );
}
